import { render, staticRenderFns } from "./DetailVideo.vue?vue&type=template&id=210d3178&"
import script from "./DetailVideo.vue?vue&type=script&lang=js&"
export * from "./DetailVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports